import React, { useState } from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	TermItem,
	useLazyInsuranceOperationsQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import useTranslation from '../../../../Hooks/useTranslation';
import Loading from '../../../../Components/Loading';
import useSelectValueGuard from '../../../Base/Hooks/useSelectValueGuard';
import useRootWorkplace from '../../../Manager/Hooks/useRootWorkplace';
import { useAppContext } from '../../../../Services/AppContext';

export interface InsuranceOperationSelectValue extends SelectValue {
	points: number;
}

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	insuranceId: string;
}

const InsuranceOperationSelect: React.FC<Props> = ({
	onChange,
	value,
	insuranceId,
}) => {
	const [isLoading, setIsLoading] = useState(true);
	const [options, setOptions] = useState<SelectValue[]>([]);
	const [getInsuranceOperations] = useLazyInsuranceOperationsQuery();
	const { userData, workplaceId } = useAppContext();
	const { rootWorkplaceId } = useRootWorkplace(workplaceId, userData.id);
	const { t } = useTranslation();

	useEffectAsync(async () => {
		if (rootWorkplaceId) {
			const { insuranceOperations } = await getInsuranceOperations({
				where: {
					insuranceId,
					workplaceId: rootWorkplaceId,
				},
			}).unwrap();

			const options: InsuranceOperationSelectValue[] = [];

			(insuranceOperations?.data || []).map(item => {
				if (item && item.points) {
					options.push({
						label: `${item.code}: ${item.title}`,
						value: item.id,
						points: item.points,
					});
				}
			});

			setOptions(options);
			setIsLoading(false);
		}
	}, [rootWorkplaceId]);

	useSelectValueGuard({ onChange, options, value });

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={value}
			noOptionsMessage='component.insuranceOperationSelect.noOptionsMessage'
		/>
	);
};
export default InsuranceOperationSelect;
